/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AditivoContratualDetalhesAliases {
  FETCH_ADITIVO = 'fetch-aditivo',
  FIELD_1 = 'field-1',
  FIELD_NR_SEQ = 'field-nrSeq',
  FORM_ADITIVO = 'form-aditivo',
  HPMS_TEXT_HTML = 'hpms-text-html',
  PANEL_ADITIVO_CONTRATUAL = 'panel-aditivo-contratual',
  TEXT_0 = 'text-0',
}
export { AditivoContratualDetalhesAliases };
